import front from '@/../static/js/proto/CtpFront';
import * as utils from '@/utils/utils';
import model from '@/../static/js/proto/Model.js';
/**
 * 订阅的函数集合
 */
const subFuns = {
  /**
   * 未触发条件单
   */
  conditionNotTriggerList(list) {
    const publish = (order: IOrderConditional) => {
      // console.log('publish conditionNotTriggerList.', order);
      utils.updArrayById(order, list);
    };
    front.conditionOrderSub({
      suberId: 'condition_order',
      publish,
      reject: (err) => console.error(err),
    });
  },
  /**
   * 资金信息
   */
  capital(obj) {
    model.capital.attach('trade', (capital) => {
      if (capital === undefined) {
        obj.rights = 0.0;
        obj.usable = 0.0;
        obj.profitAloss = 0.0;
        obj.desirable = 0.0;
        obj.account = 0.0;
        return;
      }
      obj.rights = capital.balance;
      obj.usable = capital.available;
      obj.profitAloss = capital.positionProfit;
      obj.desirable = capital.withdrawQuota;
      obj.account = capital.account;
    });
    model.trader.queryCapital.start();
  },
};
export default subFuns;



// WEBPACK FOOTER //
// ./src/store/sub-utils/subfuns.ts